import { Component, OnInit } from '@angular/core';
import { CallBackEndService } from '../call-back-end.service';
import { IbRequest } from '../ib-request';
import { IbResponse } from '../ib-response';
import { timerComponent } from "../cheque-book-request/timerComponent";
import { Router,  NavigationExtras, ActivatedRoute } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { SessionTimerComponent } from '../session-timer/session-timer.component';
import { ToastrService } from 'ngx-toastr';
declare var getHexAscii: any;
@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {
isShow : string='page1';
  error : string='';
  oldPassrequired:string='';
  oldPassword:string='';
  newPassword:string='';
  newPassrequired:string='';
  ConfNewPassrequired:string='';
  ConfNewPassword:string='';
  msgforNewPassSpace:string='';
  msgforNewPassSplChar:string='';
  msgforNewPassLen:string='';
  messageForOneCapital:string='';
  messageForOneNumber:string='';
  confpassNotMatch:string='';
  regsplchar=/[-!$%^&*()_+|~=`{}[:;<>?,.@#\]]/g;
  regchar='/^[a-zA-Z]+$/';
  regexpspace=/\s+/;
  regZeroOnly='^[0][0]*[0]$';

  reg = /[-!$%^&*()_+|~=`{}[:;<>?,.@#\]]/g;
  regNum1 = /^[0-9]+$/;

  regNum = /^.*[0-9]/;
  regexcap =/^.*?[A-Z]/;
  invalidOtp:string='';
  userName:string=''; 
  otp:string='';
  messageForSamePass="";
  constructor(  
    private webService: CallBackEndService,
   private timetStart : timerComponent,
     private router:Router,
      private spinnerService: Ng4LoadingSpinnerService,
private timer: SessionTimerComponent, private toastr: ToastrService
   ) {
     this.userName =sessionStorage.getItem('storedUserName');
   
   }

  ngOnInit() {
  
  }
  ok(){
     this.spinnerService.show();
   
   //this.scAccount=this.scAccounts[0];
    console.log("call service 345345");
      const request: IbRequest = new IbRequest();
    let response: IbResponse = null;
    request.param1 =sessionStorage.getItem('token'); 
    request.param2 =sessionStorage.getItem('storedUserName');
    
    this.webService.getResponse(request, 'logout').subscribe((data: IbResponse) => {
      console.log('logout yuiyu'+data.status);
       this.spinnerService.hide();
      if (data !== null && data.status === 'S200') {
        console.log('logout service');
       sessionStorage.removeItem('currentUser');
       sessionStorage.removeItem('isPasswordExpire');
         sessionStorage.removeItem('token');
         sessionStorage.removeItem('custNo');
         sessionStorage.removeItem('accounts');
       sessionStorage.clear();
       // this.timetStart.stopTimer();
      this.router.navigate(['/login']);          
        //this.showLoanAmount ='Hide';
      }
    });
  

  

  }
  validateNewPassword()
  {
    if (this.newPassword === '' ||this.newPassword===' ' ||this.newPassword===undefined||this.newPassword===null)
    {
      this.newPassrequired = 'no';
     

    }else if(this.newPassword.match(this.regexpspace))
    {
      this.msgforNewPassSpace= 'no';
      
    }else if(!this.newPassword.match(this.regsplchar))
    {
      this.msgforNewPassSplChar= 'no';
     
    }else if(this.newPassword.length<8)
    {
      this.msgforNewPassLen = 'no';
     
    }else if(this.newPassword.length>16)
    {
      this.msgforNewPassLen = 'no';
     
    }
    else if(!this.newPassword.match(this.regexcap))
    {
      this.messageForOneCapital='no';
     

    }
    else if(!this.newPassword.match(this.regNum))
    {
      this.messageForOneNumber='no';
      

    }else  if(this.newPassword===this.oldPassword)
  {
   this.messageForSamePass='no';
  }
  }


  clearNewPassword()
  {
    this.newPassrequired="";
    this.msgforNewPassSpace='';
    this.msgforNewPassSplChar="";
    this.msgforNewPassLen="";
    this.messageForOneCapital="";
    this.messageForOneNumber="";
    this.messageForSamePass=''; 
  }
  validateConfPassword()
  {
   
    if (this.ConfNewPassword === '' ||this.ConfNewPassword===' ' ||this.ConfNewPassword===undefined||this.ConfNewPassword===null)
    {
      this.ConfNewPassrequired='no';
     
    }else if(this.ConfNewPassword.match(this.regexpspace))
    {
      this.confpassNotMatch='space';
    }else if(!(this.ConfNewPassword===this.newPassword))
    {
      this.confpassNotMatch='no';
    }

  }
  clearConfPassword()
  {
    this.ConfNewPassrequired='';
    this.confpassNotMatch='';

  }
  openNextPage()
  {
     if (this.oldPassword === undefined || this.oldPassword === '') {
      this.oldPassrequired = 'no';
     
    }else if(this.oldPassword.match(this.regexpspace))
    {
      this.oldPassrequired= 'spaceErr';
    }
    else if (this.newPassword === '' ||this.newPassword===' ' ||this.newPassword===undefined||this.newPassword===null)
    {
      this.newPassrequired = 'no';
     
    }else if(this.newPassword.match(this.regexpspace))
    {
      this.msgforNewPassSpace= 'no';
      
    }else if(!this.newPassword.match(this.regsplchar))
    {
      this.msgforNewPassSplChar= 'no';
     
    }else if(this.newPassword.length<8)
    {
      this.msgforNewPassLen = 'no';
     
    }else if(this.newPassword.length>16)
    {
      this.msgforNewPassLen = 'no';
     
    }
    else if(!this.newPassword.match(this.regexcap))
    {
      this.messageForOneCapital='no';
     

    }
    else if(!this.newPassword.match(this.regNum))
    {
      this.messageForOneNumber='no';
    }else if(this.ConfNewPassword.match(this.regexpspace))
    {
      this.confpassNotMatch='space';
    }else  if(this.newPassword===this.oldPassword)
  {
   this.messageForSamePass='no';
  }else  if (this.ConfNewPassword === '' ||this.ConfNewPassword===' ' ||this.ConfNewPassword===undefined||this.ConfNewPassword===null)
    {
      this.ConfNewPassrequired='no';
     
    }else if(!(this.ConfNewPassword===this.newPassword))
    {
      this.confpassNotMatch='no';
      

    }else{
     this.spinnerService.show();
   if(this.oldPassword&&this.newPassword&&this.ConfNewPassword){
   const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
    
      request.param1 = getHexAscii('',this.userName);
      request.param2 = this.userName;
      this.webService.getResponse(request, 'generateOtp').subscribe((data: IbResponse) => {
      //  this.spinnerService.hide();
		response = data;
		 this.spinnerService.hide();
        if (data.status === 'S101') {
		console.log("Malic Request");
	
		}else 
        if (response !== null && response.status === 'S200')  {
          
           this.isShow='page2';
          // console.log('OTP'+JSON.stringify(response.param1));
        } else if (response !== null) {
          this.error = response.param1;
        } else {
          this.error = 'Something Went Wrong Please Contact Customer Care';
        }
      });
	}
   }
  }
  getQuickOTPValid_old() {
    if (this.otp === undefined || this.otp === '') {
      this.invalidOtp = 'no';
     
    }
  }
  getQuickOTPValid() {
    if (this.otp === undefined || this.otp === '') {
      this.invalidOtp = 'no';
     return false;
    }else if (this.otp.match(this.reg)) {
      this.invalidOtp = 'specialChar';
      return false;
    }else if (!this.otp.match(this.regNum1)) {
      this.invalidOtp = 'num';
      return false;
    } else if (this.otp.length!=6) {
      this.invalidOtp = 'len';
      return false;
    }else{
      this.invalidOtp = '';
      return true;
    }
  }
   getQuickmesageOTPRemove() {
    this.invalidOtp = '';
    this.error='';
   
  }
  validateOldPassword(){
     if (this.oldPassword === undefined || this.oldPassword === '') {
      this.oldPassrequired = 'no';
    }else if(this.oldPassword.match(this.regexpspace))
    {
      this.oldPassrequired= 'spaceErr';
      
    }
  }
  clearOldPassword()
  {
  this.oldPassrequired = '';
  }
  submit()
  {
   
   
    if(this.getQuickOTPValid() && this.otp){
       this.spinnerService.show();
    const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
    
      request.param1 = getHexAscii('', this.userName+this.oldPassword+ this.newPassword+this.otp);
      request.param2 = this.userName;
      request.param3 =getHexAscii('' ,this.oldPassword);
      request.param4 = getHexAscii('',this.newPassword);
      request.param5 = getHexAscii('',this.otp);
      this.webService.getResponse(request, 'changePasswordAfterLogin').subscribe((data: IbResponse) => {
         
        this.spinnerService.hide();
        response = data;
        if (response !== null && response.status === 'S200')  {
			this.toastr.success("",response.param1,{'easeTime':0,'closeButton':true,'timeOut':5000}); 
				this.timer.logout();
          this.error=response.param1;
          this.isShow='page3';
          // console.log('OTP'+JSON.stringify(response.param1));
        } else if (response !== null) {
          this.error = response.param1;
        } else {
          this.error = 'Something Went Wrong Please Contact Customer Care';
        }
      });
    }
  }
allValidation(){

  this.validateConfPassword();
  this.validateNewPassword();
  this.validateOldPassword();
}
}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/change-password/change-password.component.ts